import { Component } from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import querystringify from 'querystringify';

import AppBadges from '~/components/AppBadges';
import PopupClassic from '~/components/PopupClassic';

import './style.scss';

class RecruitmentView extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    language: PropTypes.string,
  };

  constructor(props) {
    super(props);
    const searchString = props.location.search;
    const query = querystringify.parse(searchString);
    const recruiter = query.u;
    this.state = {
      recruiter,
    };
  }

  render() {
    const { recruiter } = this.state;

    const registerUrl = `/signup?recruiter=${recruiter}`;

    return (
      <PopupClassic>
        <div className={classNames('recruitmentView')}>
          <h1>{I18n.t('RecruitmentView_header')}</h1>
          <AppBadges
            className="storeBadges"
            recruiter={recruiter}
          />
          <p>{I18n.t('RecruitmentView_use_web_header')}</p>
          <p>
            <a
              className="web-badge"
              href={registerUrl}
            >
              {I18n.t('RecruitmentView_use_web_button')}
            </a>
          </p>
        </div>
      </PopupClassic>
    );
  }
}

export default RecruitmentView;
